import { render, staticRenderFns } from "./GamePlayer.vue?vue&type=template&id=1611910b&scoped=true&"
import script from "./GamePlayer.vue?vue&type=script&lang=js&"
export * from "./GamePlayer.vue?vue&type=script&lang=js&"
import style0 from "./GamePlayer.vue?vue&type=style&index=0&id=1611910b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1611910b",
  null
  
)

export default component.exports